// extracted by mini-css-extract-plugin
export default {"meetingCard":"eXF441d2xDZN6Eu3eBwS"};